import React, { useState } from 'react';
import { Form, Container, Row, Col, Table } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input';
import { formatMoney } from '../../../utils/formatMoney';
import './styles/paymentTerms.scss';

function PaymentTerms() {
  const [cost, setCost] = useState(20000);
  const [retencionFuente, setRetencionFuente] = useState(0);
  const [retencionICA, setRetencionICA] = useState(0);
  const [retencionIVA, setRetencionIVA] = useState(0);

  const iva = 0.19;
  const costoPasarela = 0.0275;
  const servicioTech = 0.07;
  const feeWompi = 700;

  const handleCurrencyChange = (event, maskedvalue, floatvalue) => {
    setCost(floatvalue);
  };

  const calculateCost = () => {
    const retFuenteValue = retencionFuente * cost;
    const retICAValue = retencionICA * cost;
    const ivaValue = iva * (costoPasarela * cost + feeWompi);
    const retIVAValue = retencionIVA * ivaValue;
    const pasarelaValue = costoPasarela * cost;
    const techValue = servicioTech * cost;

    return cost - feeWompi - retFuenteValue - retICAValue - retIVAValue - ivaValue - pasarelaValue - techValue;
  };

  const handlePaymentTypeChange = e => {

    if (parseInt(e.target.value) === 1) {      
      setRetencionFuente(0);
      setRetencionICA(0);
      setRetencionIVA(0);
    } else if (parseInt(e.target.value) === 2) {
      setRetencionFuente(0.015);
      setRetencionICA(0.002);
      setRetencionIVA(0);
    }

  };

  return (
    <div className="tarifsModal">
      
      <Container style={{ marginBottom: '12px' }}>
        <Row>
          <Col>
            <div><small><strong>Método de pago</strong></small></div>
            <Form.Control as="select" onChange={handlePaymentTypeChange}>
              <option value={1}>PSE</option>
              <option value={2}>Tarjeta de crédito</option>
            </Form.Control>
          </Col>
          <Col>
          </Col>
          <Col>
            <div><small><strong>Monto</strong></small></div>
            <CurrencyInput
              className="form-control"
              prefix='COP '
              thousandSeparator=","
              precision='0'
              min={1000}
              value={cost}
              onChangeEvent={handleCurrencyChange}
            />
          </Col>
        </Row>
      </Container>

      <Container>
        <Table striped bordered hover size="sm">
          <thead>
            <tr>
              <th colSpan='2'>Calcula tu transacción</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td rowSpan='4'>Lo que se paga al estado</td>
              <td rowSpan='3'>Aplica en pagos con tarjetas de crédito</td>
              <td>Retención en la fuente (sobre el monto total)</td>
              <td>{retencionFuente * 100}%</td>
              <td>{formatMoney(retencionFuente * cost)}</td>
            </tr>
            <tr>
              <td>Retención de ICA (sobre el monto total)</td>
              <td>{retencionICA * 100}%</td>
              <td>{formatMoney(retencionICA * cost)}</td>
            </tr>
            <tr>
              <td>Retención de IVA (sobre el IVA de la pasarela)</td>
              <td>{retencionIVA * 100}%</td>
              <td>{formatMoney(retencionIVA * (iva * ((costoPasarela * cost) + feeWompi)))}</td>
            </tr>
            <tr>
              <td rowSpan='4'>Aplica siempre</td>
              <td>IVA comisión pasarela de pagos</td>
              <td>{iva * 100}%</td>
              <td>{formatMoney(iva * ((costoPasarela * cost) + feeWompi))}</td>
            </tr>
            <tr>
              <td rowSpan='2'>Costos financieros</td>
              <td>Costos pasarela de pago (por transacción)</td>
              <td>{costoPasarela * 100}%</td>
              <td>{formatMoney(costoPasarela * cost)}</td>
            </tr>
            <tr>
              <td>Fee pasarela de pago</td>
              <td>COP {feeWompi}</td>
              <td>{formatMoney(feeWompi)}</td>
            </tr>
            <tr>
              <td>Pago servicio nibi</td>
              <td>Servicios de tecnología y mercadeo</td>
              <td>{(servicioTech * 100).toFixed(2)}%</td>
              <td>{formatMoney(servicioTech * cost)}</td>
            </tr>
            <tr>
              <td colSpan='4' style={{ textAlign: 'center' }}>
                <strong>
                  Recibes
              </strong>
              </td>
              <td>
                <strong>
                  {formatMoney(calculateCost())}
                </strong>
              </td>
            </tr>
          </tbody>
        </Table>
      </Container>
    </div>
  );
}

export default PaymentTerms;
